// import Vue from 'vue';
// import Router from 'vue-router';
// import store from '@/store/index';

// import { checkLoginStatus } from './router-guard';
// import { post } from '@/store/modules/fsm/index';
// import PageTitles from '@/constants/page-titles'

import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import store from '@/store/index';

import { checkLoginStatus } from './router-guard';
import { post } from '@/store/modules/fsm/index';
import PageTitles from '@/constants/page-titles';

import LoginPage from "@/components/public-layouts/LoginPage";
import OrgSelectionPage from "@/components/public-layouts/OrgSelectionPage";
import PrivacyPolicy from "@/components/public-layouts/PrivacyPolicy"
import TermsConditions from "@/components/public-layouts/TermsConditions"
import InformationProtection from "@/components/public-layouts/InformationProtection"
import WelcomePage from "@/components/private-layouts/welcome/WelcomePage";
import AuditLogPage from "@/components/private-layouts/audit/AuditLogPage";
import AdministrationPage from "@/components/private-layouts/administration/AdministrationPage";
import BreakGlassPage from "@/components/private-layouts/administration/BreakGlassPage";
import GroupsPage from "@/components/private-layouts/groups/GroupsPage";
import PrivilegesPage from "@/components/private-layouts/privileges/PrivilegesPage";
import PrivilegeReportsPage from "@/components/private-layouts/administration/PrivilegeReportsPage";
import DirectiveReauthPolicyPage from "@/components/private-layouts/administration/DirectiveReauthPolicyPage";
import CustomizationPage from "@/components/private-layouts/administration/CustomizationPage";
import WelcomeMedicalReports from "@/components/private-layouts/welcome/WelcomeMedicalReports";
import WelcomeHealthRecords from "@/components/private-layouts/welcome/WelcomeHealthRecords";
import ProviderPage from "@/components/private-layouts/providers/ProviderPage";
import ProvidersPage from "@/components/private-layouts/providers/ProvidersPage";
import ProceduresPage from '@/components/private-layouts/procedures/ProceduresPage';
import DiagnosisPage from '@/components/private-layouts/diagnosis/DiagnosisPage';
import MedicationPage from '@/components/private-layouts/medication/MedicationPage';
import VaccinationPage from '@/components/private-layouts/vaccination/VaccinationPage';
import CdaPage from '@/components/private-layouts/CdaPage';
import CdaContentBody from '@/components/includes/cda/CdaContentBody';
import ReportsPage from '@/components/private-layouts/ReportsPage';
import ReportContentBody from '@/components/includes/report/ReportContentBody';
import PdfsPage from '@/components/private-layouts/PdfsPage';
import PdfContentBody from '@/components/includes/pdf/PdfContentBody';
import WatchPage from '@/components/private-layouts/WatchPage';
import VitalsPage from '@/components/private-layouts/VitalsPage';
import VitalsGroupPage from '@/components/private-layouts/VitalsGroupPage';
import UserProfile from '@/components/private-layouts/UserProfile';
import ChangePasswordPage from '@/components/private-layouts/ChangePasswordPage';
import UserDevices from '@/components/private-layouts/UserDevices';
import UserContacts from '@/components/private-layouts/contact/UserContacts';
import LoadingPage from '@/components/Loading';
import RegisterPage from '@/components/public-layouts/register/RegisterPage';
import PageNotFound from '@/components/private-layouts/404/PageNotFound';
import SearchPage from '@/components/private-layouts/search/SearchPage';
import AllergyModule from '@/components/private-layouts/allergy/AllergyModule';
//import AllergyPage from '@/components/private-layouts/allergy/AllergyPage';
import FilterableSortablePage from '@/components/includes/FilterableSortablePage';
import DirectivesListPage from '@/components/private-layouts/directives/DirectivesListPage';
import DirectivesDetailPage from '@/components/private-layouts/directives/DirectivesDetailPage';
import ForgotPasswordPage from '@/components/public-layouts/ForgotPasswordPage';
import ResetPasswordPage from '@/components/public-layouts/ResetPasswordPage';
import VerificationPage from '@/components/public-layouts/VerificationPage';
import DataUploadPage from '@/components/private-layouts/DataUploadPage';
import NotesPage from '@/components/private-layouts/NotesPage';
import ProfessionalNotesPage from '@/components/private-layouts/ProfessionalNotesPage';
import OrdersPage from '@/components/private-layouts/OrdersPage';
import CurrentDiag from '@/components/private-layouts/currents/CurrentDiag'
import CurrentMed from '@/components/private-layouts/currents/CurrentMed'
import InactiveMedications from '@/components/private-layouts/currents/InactiveMedications'
import MedAdmin from '@/components/private-layouts/currents/MedAdmin'
import PrePourPrototype from '@/components/private-layouts/prepour-prototype/PrePourPrototype'
import PatientMediaPrototype from '@/components/private-layouts/media/PatientMediaPrototype'
import CurrentProc from '@/components/private-layouts/currents/CurrentProc'
import CurrentProviders from '@/components/private-layouts/currents/CurrentProviders'
import CurrentNurse from '@/components/private-layouts/nurses/CurrentNurse';
import PatientNurse from '@/components/private-layouts/nurses/PatientNurse';
import MyAccount from '@/components/private-layouts/myaccount/MyAccount';
import CptBilling from '@/components/private-layouts/CptBilling'
import CptPage from '@/components/private-layouts/CptPage.vue'
import VerifyNursePage from '@/components/public-layouts/VerifyNursePage.vue' 
import VerifyAccountPage from '@/components/public-layouts/VerifyAccountPage.vue'
import VerifyContactPage from '@/components/public-layouts/VerifyContactPage.vue'
import VerifyProviderPage from '@/components/public-layouts/VerifyProviderPage.vue'
import SixDigitAuth from '@/components/public-layouts/SixDigitAuth.vue'
import PatientCards from '@/components/private-layouts/patients/PatientCards';
import AlliedProfPage from '@/components/private-layouts/providers/AlliedProfPage.vue';
import CurrentAide from '@/components/private-layouts/nurses/homehealthAide/CurrentAid.vue';
import ManageScheduling from '@/components/private-layouts/scheduling/ManageScheduling.vue';
import {
  LoginNavigation,
  RootNavigation,
  WelcomeNavigation,
  ProviderNavigation,
  ProceduresNavigation,
  LabsNavigation,
  DiagnosisNavigation,
  MedicationsNavigation, VaccinationNavigation, CdasNavigation, CdaNavigation,
  ReportsNavigation, ReportNavigation, PdfsNavigation, PdfNavigation, WatchNavigation,
  UserProfileNavigation,UserContactNavigation,ChangePasswordNavigation,MedicalReportsNavigation, HealthRecordsNavigation,
  ProvidersNavigation,
  Logout, RegisterNavigation, AdminRegisterNavigation, PageNotFoundNavigation, SearchPageNavigation, AllergyNavigation,
  RequestPasswordResetNavigation, // ForgotPasswordPage
  PasswordResetNavigation, // ResetPasswordPage
  ConfirmRegistrationNavigation, // VerificationPage
  DataUploadNavigation, VitalsNavigation, VitalsGroup, DirectivesNavigation,
  UserDevicesNavigation, NotesNavigation, ProfessionalNotesNavigation, CurrentProcNavigation, CurrentDiagNavigation, CurrentMedNavigation,
  CurrentProvNavigation, OrdersNavigation,CurrentNurseNavigation,MedAdminNavigation,MyAccountNavigation, CptBillingNavigation,
  CptNavigation, VerifyNurseNavigation, VerifyAccountNavigation, VerifyProviderNavigation, VerifyContactNavigation, PatientNurseNavigation, 
  PrivacyPolicyNavigation, TermsConditionsNavigation, InformationProtectionNavigation, sixDigitNavigation, PatientCardNavigation, AllergyModuleNavigation,
  AlliedCardNavigation,HomeHealthAidNavigation,ProviderSchedulingNavigation
} from '@/store/modules/fsm/messages';

// if (!process || process.env.NODE_ENV !== 'test') {
//   Vue.use(Router)
// // }
const router = createRouter({
  history: createWebHashHistory(),
  routes:[
    { path: '/login', component: LoginPage, name: LoginNavigation, meta: {title: PageTitles.TITLE_LOGIN},
      props: route => ({ dest: route.query.dest })
    },
    { path: '/org-selection', component: OrgSelectionPage, name: 'OrgSelectionNavigation', meta: {title: 'Organization Selection'} },
    { path: '/register', component: RegisterPage, name: RegisterNavigation, meta: {title: PageTitles.TITLE_REGISTER} },
    { path: '/adminregister', component: RegisterPage, name: AdminRegisterNavigation, meta: {title: PageTitles.TITLE_REGISTER} },
    { path: '/', component: LoadingPage, name: RootNavigation, meta: {title: PageTitles.TITLE_LOGIN} },
    { path: '/privacy-policy', component: PrivacyPolicy, name: PrivacyPolicyNavigation, meta: {title: PageTitles.TITLE_PRIVACY_POLICY} },
    { path: '/terms', component: TermsConditions, name: TermsConditionsNavigation, meta: {title: PageTitles.TITLE_TERMS_CONDITIONS} },
    { path: '/protection', component: InformationProtection, name: InformationProtectionNavigation, meta: {title: PageTitles.TITLE_INFORMATION_PROTECTION} },
    { path: '/welcome', component: WelcomePage,name: WelcomeNavigation, meta: {title: PageTitles.TITLE_WELCOME} },
    { path: '/notes', component: NotesPage,name: NotesNavigation, meta: {title: PageTitles.TITLE_NOTES} },
    { path: '/professional-notes', component: ProfessionalNotesPage, name: ProfessionalNotesNavigation, meta: {title: PageTitles.TITLE_NOTES} },
    { path: '/cpt', component: CptPage, name: CptNavigation, meta: {title: PageTitles.TITLE_CPT_PAGE} },
    { path: '/cptBilling', component: CptBilling, name: CptBillingNavigation, meta: {title: PageTitles.TITLE_CPT_BILLING} },
    { path: '/orders', component: OrdersPage, name: OrdersNavigation, meta: {title: PageTitles.TITLE_ORDERS} },
    { path: '/medical-reports', name: MedicalReportsNavigation, component: WelcomeMedicalReports, meta: {title: PageTitles.TITLE_WELCOME} },
    { path: '/health-records', name: HealthRecordsNavigation, component: WelcomeHealthRecords, meta: {title: PageTitles.TITLE_WELCOME} },
    { path: '/providers', name: ProvidersNavigation, component: FilterableSortablePage, meta: {title: PageTitles.TITLE_PROVIDERS} },  
    { path: '/providers/alliedprofessional', name: AlliedCardNavigation, component: AlliedProfPage, meta: {title: PageTitles.TITLE_ALLIEDPROFS} }, 
    { path: '/nurse/homehealthaide', name: HomeHealthAidNavigation, component: CurrentAide, meta: {title: PageTitles.TITLE_HOME_HEALTH_AIDE} }, 
    { path: '/scheduling', name: ProviderSchedulingNavigation, component: ManageScheduling, meta: { title: PageTitles.TITLE_SCHEDULING} },
    { path: '/vitals', component: VitalsPage, name: VitalsNavigation, meta: { title: PageTitles.TITLE_VITALS}, props: true },
    { path: '/vitalsGroup', component: VitalsGroupPage, meta: { title: PageTitles.TITLE_VITALS}, props: true,
      children: [
        {
          path: ':grouping',
          name: VitalsGroup,
          component: VitalsGroupPage,
          meta: {title: PageTitles.TITLE_VITALS}
        }
      ]},  
    { path: '/provider', component: ProviderPage, meta: {title: PageTitles.TITLE_PROVIDER},
      children: [
        {
          path: ':specialty/:id',
          name: ProviderNavigation,
          component: ProviderPage,
          meta: {title: PageTitles.TITLE_PROVIDER}
        }
      ]
    },
    // { path: '/provider/:specialty/:id', component: ProviderPage,name: ProviderNavigation, meta: {title: PageTitles.TITLE_PROVIDER} },
    { path: '/procedureKinds', component: FilterableSortablePage,name: ProceduresNavigation, meta: {title: PageTitles.TITLE_PROCEDURES} },
    { path: '/labKinds', component: FilterableSortablePage, name: LabsNavigation, meta: {title: PageTitles.TITLE_LABS} },
    { path: '/diagnosis', component:FilterableSortablePage,name: DiagnosisNavigation, meta: {title: PageTitles.TITLE_DIAGNOSIS} },
    { path: '/medication', component: FilterableSortablePage,name: MedicationsNavigation, meta: {title: PageTitles.TITLE_MEDICATION} },
    { path: '/currentProcedures', component: CurrentProc, name: CurrentProcNavigation, meta: {title: PageTitles.TITLE_CURRENT_PROC}},
    { path: '/currentMedications', component: CurrentMed, name: CurrentMedNavigation, meta: {title: PageTitles.TITLE_CURRENT_MED}},
    { path: '/inactiveMedications', component: InactiveMedications, name: 'InactiveMedicationsNavigation', meta: {title: 'Inactive Medications'}},
    { path: '/medAdministration', component: MedAdmin, name: MedAdminNavigation, meta: {title: PageTitles.TITLE_MED_ADMIN}},
    { path: '/sixDigitAuthorization', component:SixDigitAuth, name:sixDigitNavigation, meta: {title: PageTitles.TITLE_SIXDIGIT_CODE}},
    { path: '/patients', component:PatientCards, name:PatientCardNavigation, meta: {title: PageTitles.TITLE_PATIENT_CARDS}},
    { path: '/prePourMedication', component: PrePourPrototype, name: 'PrePourMedication', meta: {title: 'Pre-Pour Medication'}},
    { path: '/patientMedia', component: PatientMediaPrototype, name: 'PatientMedia', meta: {title: 'Patient Media'}},
    { path: '/currentDiagnosis', component: CurrentDiag, name: CurrentDiagNavigation, meta: {title: PageTitles.TITLE_CURRENT_DIAG}},
    { path: '/currentProviders', component: CurrentProviders, name: CurrentProvNavigation, meta: {title: PageTitles.TITLE_CURRENT_PROV}},
    { path: '/currentNurse', component: CurrentNurse, name: CurrentNurseNavigation, meta: {title: PageTitles.TITLE_CURRENT_NURSE}},
    { path: '/user/nursesettings', redirect: '/currentNurse' },
    { path: '/patientNurse', component: PatientNurse, name: PatientNurseNavigation, meta: {title: PageTitles.TITLE_PATIENT_NURSE}},
    { path: '/myOrg', component: MyAccount, name: MyAccountNavigation, meta: {title: PageTitles.TITLE_MY_ORG}},
      // children: [
      //   path: '/verify',

      // ]
    //},
    { path: '/vaccination//', component: FilterableSortablePage,name: VaccinationNavigation, meta: {title: PageTitles.TITLE_VACCINATION} },
    /*
    { path: '/cdas', component: CdaPage, name: CdasNavigation, meta: {title: PageTitles.TITLE_CDA},
      children: [
        {
          path: ':index/:type?/:id?',
          name: CdaNavigation,
          component: CdaContentBody,
          meta: {title: PageTitles.TITLE_CDA},
          props: true
        },
      ]
    },*/
    {
      name: CdasNavigation,
      path: '/cdas/:selectedCda?/:selectedType?/:selectedId?',
      component: CdaPage,
      props: route => {
        const p = {};
        // Optional segments can be "" (not undefined). Number("") === 0, which wrongly selects index 0.
        const rawCda = route.params.selectedCda;
        if (rawCda !== undefined && rawCda !== null && String(rawCda).trim() !== '') {
          const n = Number(rawCda);
          if (!Number.isNaN(n)) {
            p.selectedCda = n;
          }
        }
        const rawType = route.params.selectedType;
        if (rawType !== undefined && rawType !== null && String(rawType).trim() !== '') {
          p.selectedType = rawType;
        }
        const rawId = route.params.selectedId;
        if (rawId !== undefined && rawId !== null && String(rawId).trim() !== '') {
          const idNum = Number(rawId);
          if (!Number.isNaN(idNum)) {
            p.selectedId = idNum;
          }
        }
        return p;
      },
      meta: {title: PageTitles.TITLE_PDF}
    },

    /*
    { path: '/reports', component: ReportsPage, name: ReportsNavigation, meta: {title: PageTitles.TITLE_REPORTS},
      children: [
        {
          path: ':index',
          name: ReportNavigation,
          component: ReportContentBody,
          meta: {title: PageTitles.TITLE_REPORTS}
        },
      ]
    },
    */
   {
      name: ReportNavigation,
      path: '/report/:selectedReport',
      component: ReportsPage,
      props: route => {
        if(route.params.selectedReport !== undefined)
          return { selectedReport: Number(route.params.selectedReport) };
        else
          return {};
      },
    meta: {title: PageTitles.TITLE_REPORT},
   },
   { path: '/reports', component:FilterableSortablePage,name: ReportsNavigation, meta: {title: PageTitles.TITLE_REPORTS} },
   /*
    { path: '/pdfs', component: PdfsPage, name: PdfsNavigation, meta: {title: PageTitles.TITLE_PDF},
      children: [
        {
          path: ':index',
          name: PdfNavigation,
          component: PdfContentBody,
          meta: {title: PageTitles.TITLE_PDF}
        },
      ]
    },
    */
    {
      name: PdfsNavigation,
      path: '/pdfs/:selectedPdf?',
      component: PdfsPage,
      props: route => {
        let x = route.params.selectedPdf === undefined ? 
          {} : { selectedPdf : Number(route.params.selectedPdf)};
        return x;
      },
      meta: {title: PageTitles.TITLE_DOCUMENTS}
    },
    /*
    {
      name: PdfNavigation,
      path: '/pdf/:index',
      component: PdfsPage,
      meta: {title: PageTitles.TITLE_PDF}
     },
     */
    { path: '/data-upload', component: DataUploadPage, name: DataUploadNavigation, meta: {title: PageTitles.DATA_UPLOAD}},
    { path: '/watch', component: WatchPage,name: WatchNavigation, meta: {title: PageTitles.TITLE_WATCH}, props: true},
    { path: '/user/profile', component: UserProfile,name: UserProfileNavigation, meta: {title: PageTitles.TITLE_PROFILE},props:{restricted:true}},
    { path: '/user/change-password', component: ChangePasswordPage, name: ChangePasswordNavigation, meta: { title: PageTitles.TITLE_CHANGE_PASSWORD } },
    { path: '/user/contact', component: UserContacts,name: UserContactNavigation, meta: {title: PageTitles.TITLE_CONTACT},props:{restricted:true}},
    { path: '/user/devices', component: UserDevices,name: UserDevicesNavigation, meta: {title: PageTitles.TITLE_DEVICES},props:{restricted:true}},
    { path: '/logout', component: LoginPage, name: Logout, meta: {title: PageTitles.TITLE_LOGIN}},
    { path: '/404', component: PageNotFound, name: PageNotFoundNavigation, meta: {title: PageTitles.TITLE_404}},
    { path: '/search', component: SearchPage, name: SearchPageNavigation, meta: {title: PageTitles.TITLE_SEARCH}},
    { path: '/directives', component: DirectivesListPage, name: DirectivesNavigation, meta: {title: PageTitles.TITLE_DIRECTIVES}},
    // (DirectivesNavigation name stays on the list route — the nav link routes to the list.)
    { path: '/directives/:patientId', component: DirectivesDetailPage, name: 'DirectivesDetailNavigation', meta: {title: PageTitles.TITLE_DIRECTIVES}, props: true},
   // { path: '/allergy', component: FilterableSortablePage, name: AllergyNavigation, meta: {title: PageTitles.TITLE_ALLERGY} },
    { path: '/allergy', component: AllergyModule, name: AllergyNavigation, meta: {title: PageTitles.TITLE_ALLERGY} },
    { path: '/forgot', component: ForgotPasswordPage, name: RequestPasswordResetNavigation, meta: {title: PageTitles.TITLE_FORGOT} },
    { path: '/reset', component: ResetPasswordPage, name: PasswordResetNavigation, meta: {title: PageTitles.TITLE_RESET}  },
    { path: '/verify', component: VerificationPage, name: ConfirmRegistrationNavigation, meta: {title: PageTitles.TITLE_VERIFY}  },
    { path: '/verifyNurse', component: VerifyNursePage, name: VerifyNurseNavigation, meta: {title: PageTitles.TITLE_VERIFY_NURSE },
      // invite: the nurse invite e-mail's single-use token, sent back as the X-Pacmny-Invite header.
      props: route => ({ accountType: route.query.accountType, unique: route.query.unique, accntnum: route.query.accntnum, invite: route.query.invite })
    },
    { path: '/verifyAccount', component: VerifyAccountPage, name: VerifyAccountNavigation, meta: {title: PageTitles.TITLE_VERIFY_ACCOUNT },
      props: route => ({ accountType: route.query.accountType, unique: route.query.unique, accntnum: route.query.accntnum })
    },
    { path: '/verifyProvider', component: VerifyProviderPage, name: VerifyProviderNavigation, meta: {title: PageTitles.TITLE_VERIFY_PROVIDER },
      // Query params come from med-order invite email or pending Add User email.
      props: route => ({
        accountType: route.query.accountType || 'Provider',
        unique: route.query.unique,
        accntnum: route.query.accntnum,
        firstName: route.query.firstName,
        lastName: route.query.lastName,
        npi: route.query.npi,
        email: route.query.email,
        patientUniqueId: route.query.patientUniqueId,
        // Single-use invite token (keyon plan §7.24); sent back as the X-Pacmny-Invite header.
        invite: route.query.invite,
      })
    },
    { path: '/verifyContact', component: VerifyContactPage, name: VerifyContactNavigation, meta: {title: 'Contact Verification' },
      props: route => ({ invitation: route.query.invitation, firstName: route.query.firstName, lastName: route.query.lastName, email: route.query.email, relationType: route.query.relationType, inviterAccountNumber: route.query.inviterAccountNumber, inviterName: route.query.inviterName })
    },
    { path: '/administration', component: AdministrationPage, name: 'AdministrationNavigation', meta: {title: 'Administration'} },
    { path: '/break-glass', component: BreakGlassPage, name: 'BreakGlassNavigation', meta: {title: 'Break-Glass'} },
    { path: '/groups', component: GroupsPage, name: 'GroupsNavigation', meta: {title: PageTitles.TITLE_GROUPS} },
    { path: '/privileges', component: PrivilegesPage, name: 'PrivilegesNavigation', meta: {title: 'Privileges'} },
    { path: '/privilege-reports', component: PrivilegeReportsPage, name: 'PrivilegeReportsNavigation', meta: {title: 'Privilege Reports'} },
    { path: '/directive-reauth-rules', component: DirectiveReauthPolicyPage, name: 'DirectiveReauthRulesNavigation', meta: {title: 'Directive Re-authorization Rules'} },
    { path: '/customization', component: CustomizationPage, name: 'CustomizationNavigation', meta: {title: 'Customization'} },
    { path: '/audit', component: AuditLogPage, name: 'AuditLogNavigation', meta: {title: 'HIPAA Audit Log'} }
  ],
});

// redirect to login page if user is not logged in
router.beforeEach( async (to, from, next) => {
  // Legacy invite emails used /#register instead of /#/register (hash-mode route).
  const hash = window.location.hash;
  if (hash === '#register') {
    next({ path: '/register', replace: true });
    return;
  }
  if (hash === '#adminregister') {
    next({ path: '/adminregister', replace: true });
    return;
  }

  checkLoginStatus(to, from, next);

  document.title = to.meta.title
});

export default router;
